import GATSBY_COMPILED_MDX from "D:/Projects/knu-p4c-lab.github.io/posts/publications/MobyDick An Interactive Multi-swimmer Exergame.mdx";
import React from 'react';
import Layout from "./layout";
import Seo from "./seo";
import {A, H4, Span} from "./typography";
import MdxTemplate from "./mdx-template";
const PublicationTemplate = _ref => {
  let {data, children} = _ref;
  const {publication} = data;
  const {title, date, type, authors, publisher, abbrev, volume, issue, pages, doi} = (publication === null || publication === void 0 ? void 0 : publication.frontmatter) || ({});
  const pubAbbrev = publisher && abbrev ? `${publisher} (${abbrev})` : publisher;
  const volIssue = volume && issue ? `${volume} (${issue})` : volume;
  const pubLine = [pubAbbrev, volIssue, pages].filter(p => p !== undefined && p !== null).join(', ');
  return React.createElement(Layout, {
    activeLink: "publications"
  }, React.createElement("div", null, React.createElement("div", {
    className: "flex flex-col items-start space-y-2 text-base font-serif"
  }, React.createElement(Span, {
    className: "leading-none text-gray-400 dark:text-gray-500"
  }, date || ''), React.createElement(H4, {
    className: "capitalize font-sans"
  }, "[", type, "] ", title), authors && React.createElement(Span, {
    className: "leading-1"
  }, authors.join(', '), " "), publisher && React.createElement(Span, {
    className: "italic"
  }, pubLine), doi && React.createElement(A, {
    href: `https://doi.org/${doi}`
  }, "DOI: ", doi)), React.createElement("hr", {
    className: "my-6"
  }), React.createElement(MdxTemplate, null, children)));
};
const pageQuery = "433653831";
export const Head = _ref2 => {
  var _data$publication, _data$publication$fro;
  let {data} = _ref2;
  return React.createElement(Seo, {
    title: `Publication - ${(_data$publication = data.publication) === null || _data$publication === void 0 ? void 0 : (_data$publication$fro = _data$publication.frontmatter) === null || _data$publication$fro === void 0 ? void 0 : _data$publication$fro.title}`
  });
};
PublicationTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(PublicationTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
